import React, { useRef } from "react";
import NoDataFound from "../../../Extra/NoDataFound";
import DownloadExcel from "../../../Extra/DownloadExcel";
const CUMonthWise = ({ data }) => {
  const tableRef = useRef();
  return (
    <div className="newUiBody">
      <h5 className="text-white bg-black p-1 mb-1 "> Month wise Utilization</h5>
      <div
        className="table-responsive  m-0 p-0"
        style={{ height: "400px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-hover table-striped flex-grow-1"
          ref={tableRef}
        >
          <thead className="table-dark">
            <tr>
              <th>Sno</th>
              <th>Month</th>
              <th>Util %</th>
              <th>Util (Freight)%</th>
            </tr>
          </thead>
          <tbody>
            {data && data.utfData.length > 0 ? (
              data.utfData.map((obj, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{obj.time}</td>
                    <td>{obj["ut %"]}</td>
                    <td>{obj["utf %"]}</td>
                  </tr>
                );
              })
            ) : (
              <NoDataFound />
            )}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`Lobby wise utilization`} />
    </div>
  );
};
export default CUMonthWise;
